<template>
  <div class="text-center">
    <v-menu offset-y>
      <template v-slot:activator="{ on }">
        <v-btn
          color="black"
          dark
          v-on="on"
        >
        <v-icon dark>list</v-icon>

        </v-btn>
      </template>
      <v-list>

        <v-list-tile
          @click="toHome()"
          v-scroll-to="'#uns'"

        >
          <v-list-tile-title>Über uns</v-list-tile-title>
        </v-list-tile>

        <v-list-tile
          @click="toHome()"
          v-scroll-to="'#keller'"

        >
          <v-list-tile-title>Teutonenkeller</v-list-tile-title>
        </v-list-tile>

        <v-list-tile
          @click="toHome()"
          v-scroll-to="'#wg'"
        >
          <v-list-tile-title>Teutonen WG</v-list-tile-title>
        </v-list-tile>
        <!--
        <v-list-tile
          @click="toRegistration()"
        >
          <v-list-tile-title>Anmeldung zum Stife</v-list-tile-title>
        </v-list-tile>
        -->

        <v-list-tile
          @click="toDatenschutz()"
        >
          <v-list-tile-title>Datenschutz</v-list-tile-title>
        </v-list-tile>

        <v-list-tile
          @click="toImpressum()"
        >
          <v-list-tile-title>Impressum</v-list-tile-title>
        </v-list-tile>
        <v-list-tile>
           <v-list-tile-title><a class="black--text" href="/Semesterprogramm-WS26-27.pdf" download>Semesterprogramm als PDF</a></v-list-tile-title>
        </v-list-tile>
                <v-list-tile>
               <v-list-tile-title><a class="black--text" href="/Semesterprogramm-WS26-27.ics" download>Semesterprogramm als Kalender</a></v-list-tile-title>
        </v-list-tile>

      </v-list>
    </v-menu>
  </div>
</template>
<script>
export default {
  methods: {
    toImpressum() {
      this.$router.push({ name: 'impressum' });
    },
    toDatenschutz() {
      this.$router.push({ name: 'datenschutz' });
    },
    toHome() {
      this.$router.push({ name: 'home' });
    },
    toRegistration() {
      this.$router.push({ name: 'registration' });
    },
  },
};
</script>
